import { UserService } from '@/app/services';
import {
  selectErrorInfo,
  selectIsIdPError,
} from '@/app/store/selectors/error.selectors';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';

import { Store } from '@ngrx/store';

@Component({
  selector: 'app-error',
  imports: [MatButtonModule],
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss',
})
export class ErrorComponent {
  readonly router = inject(Router);
  readonly store = inject(Store);
  readonly userService = inject(UserService);

  isIdPError;
  errorInfo;

  constructor() {
    this.isIdPError = this.store.selectSignal(selectIsIdPError);
    this.errorInfo = this.store.selectSignal(selectErrorInfo);
  }

  public handleLoginClick(event: MouseEvent | KeyboardEvent) {
    if (event.altKey) {
      this.router.navigate(['/login'], { queryParams: { firstech: true } });
    } else {
      this.userService.login();
    }
  }
}
